import React, { ElementType } from 'react';
import { EventRegistrationPricingOptionGroup } from '../generated/api/dsv-public/model';
import { CheckboxOptionField } from './CheckboxOptionField';
import { RadioOptionField } from './RadioOptionField';

type PricingGroupFieldComponentProps = {
  optionGroupProps: EventRegistrationPricingOptionGroup;
  defaultValues?: number[];
  onChangeFieldValue: (optionGroupId: number, selectedOptions: number[]) => void;
};

export const PricingGroupFieldComponent: React.FC<PricingGroupFieldComponentProps> = ({
  optionGroupProps,
  defaultValues,
  onChangeFieldValue,
}) => {
  const Component: ElementType =
    optionGroupProps.maxOptions === 1 && optionGroupProps.required ? RadioOptionField : CheckboxOptionField;

  return (
    <Component
      {...optionGroupProps}
      defaultValues={defaultValues}
      fieldKey={optionGroupProps.optionGroupId}
      onChangeFieldValue={onChangeFieldValue}
    />
  );
};
